import Card from "components/card";
import BarChart from "components/charts/BarChart";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { barChartOptionsDailyTraffic } from "utils/charts";

const DailyTraffic = ({ analyticsData = [] }) => {
  const transformData = (data) => {
    if (!Array.isArray(data)) {
      return {
        labels: [],
        series: [{ name: "Visitors", data: [] }],
        percentageChange: 0,
      };
    }

    const aggregatedData = {};
    const weeklyData = {};

    data.forEach((row) => {
      if (!row || !row.dimensionValues || !row.metricValues) {
        return;
      }

      const rawDate = row.dimensionValues[0]?.value;
      if (!rawDate) return;

      const formattedDate = `${rawDate.slice(0, 4)}-${rawDate.slice(
        4,
        6
      )}-${rawDate.slice(6, 8)}`;
      const visitorCount = parseInt(row.metricValues[0]?.value || "0", 10);

      if (aggregatedData[formattedDate]) {
        aggregatedData[formattedDate] += visitorCount;
      } else {
        aggregatedData[formattedDate] = visitorCount;
      }

      const dateObj = new Date(formattedDate);
      const weekNumber = `${dateObj.getFullYear()}-W${Math.ceil(
        dateObj.getDate() / 7
      )}`;

      if (weeklyData[weekNumber]) {
        weeklyData[weekNumber] += visitorCount;
      } else {
        weeklyData[weekNumber] = visitorCount;
      }
    });

    const sortedDates = Object.keys(aggregatedData).sort(
      (a, b) => new Date(a) - new Date(b)
    );
    const sortedVisitors = sortedDates.map((date) => aggregatedData[date]);

    const weeks = Object.keys(weeklyData).sort();
    const lastWeek = weeklyData[weeks[weeks.length - 1]] || 0;
    const previousWeek = weeklyData[weeks[weeks.length - 2]] || 0;

    let percentageChange = 0;
    if (previousWeek > 0) {
      percentageChange = ((lastWeek - previousWeek) / previousWeek) * 100;
    }

    return {
      labels: sortedDates,
      series: [{ name: "Visitors", data: sortedVisitors }],
      percentageChange,
    };
  };

  const barChartDataDailyTraffic = transformData(analyticsData || []);
  const percentageChange = barChartDataDailyTraffic.percentageChange.toFixed(2);
  const isPositive = percentageChange >= 0;

  const latestDate =
    barChartDataDailyTraffic.labels[barChartDataDailyTraffic.labels.length - 1];
  const latestVisitorCount =
    barChartDataDailyTraffic.series[0]?.data[
      barChartDataDailyTraffic.labels.indexOf(latestDate)
    ] || 0;

  return (
    <Card extra="pb-7 p-[20px]">
      <div className="flex flex-row justify-between">
        <div className="ml-1 pt-2">
          <p className="text-sm font-medium leading-4 text-gray-600">
            Daily Traffic
          </p>
          <p className="text-[34px] font-bold text-navy-700 dark:text-white">
            {latestVisitorCount}{" "}
            <span className="text-sm font-medium leading-6 text-gray-600">
              Visitors Today
            </span>
          </p>
        </div>
        <div className="mt-2 flex items-start">
          <div
            className={`flex items-center text-sm ${
              isPositive ? "text-green-500" : "text-red-500"
            }`}
          >
            {isPositive ? (
              <MdArrowDropUp className="h-5 w-5" />
            ) : (
              <MdArrowDropDown className="h-5 w-5" />
            )}
            <p className="font-bold"> {percentageChange}% </p>
          </div>
        </div>
      </div>

      <div className="h-[300px] w-full pb-0 pt-10">
        {barChartDataDailyTraffic.labels?.length > 0 ? (
          <BarChart
            chartData={barChartDataDailyTraffic}
            chartOptions={barChartOptionsDailyTraffic}
          />
        ) : (
          <p className="text-center text-gray-600">No data available</p>
        )}
      </div>
    </Card>
  );
};

export default DailyTraffic;
